import 'reflect-metadata';
import { Relation } from '../core/decorators/relation.decorator';
import { BaseEntity } from '../core/entities/base.entity';
import { RelationRef } from '../core/types/entity-types';
import { LearningUnitEntity } from '../learning-unit/learning-unit-entity';
import { LearningSectionContainerEntity } from './learning-section-container/learning-section-container-entity';
import { LearningSectionLayoutEntity } from './learning-section-layout/learning-section-layout-entity';
import { ConsumerEntity } from '../consumer/consumer.entity';
import { SubjectEntity } from '../subject/subject.entity';
import { ConsumerData } from '../core/types';

export interface SectionRowContainerData {
  type: 'containers'
  containerIds: (string | null)[]
}

export interface ButtonBarItemData {
  label: string
  contentType?: string | null
  contentId?: string | null
  consumerId?: string | null
}

export interface SectionRowButtonBarData {
  type: 'button-bar'
  items: ButtonBarItemData[]
}

export type SectionRowData = SectionRowContainerData | SectionRowButtonBarData;

export class LearningSectionEntity extends BaseEntity {
  name!: string;
  title!: string;
  learningSectionType!: string;

  consumerData?: ConsumerData;
  showCopyright?: boolean;
  version?: number;
  sectionRows?: SectionRowData[];
  is_mandatory?: boolean;

  @Relation()
  learningUnits?: RelationRef<LearningUnitEntity>[];

  @Relation()
  learningSectionContainers?: RelationRef<LearningSectionContainerEntity>[];

  @Relation()
  learningSectionLayout?: RelationRef<LearningSectionLayoutEntity>[];

  @Relation()
  consumer?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];
}
